














import Vue from 'vue'
import { store } from '@/store'
export default Vue.extend({
    name: 'FeaturesOfMotif',
    props: ['motifid'],
    data() {
        return {
            columns: [{
                name: 'name',
                label: 'Feature',
                sortable: true,
                field: 'name'
            }, {
                name: 'prob',
                field: 'prob',
                sortable: true,
                label: 'Probability'
            }],
            pagination: {
                sortBy: 'prob',
                descending: true,
                rowsPerPage: 25
            }
        }
    },
    computed: {
        data() {
            const beta = store.state.dataset.beta[this.motifid];
            return Object.entries(beta).map(([name, prob]) => {
                return { name, prob}
            });
        },
        total() {
            const beta = store.state.dataset.beta[this.motifid];
            return Object.values(beta).reduce((a ,c) => a + c);
        }
    }
})
